import location from './location.vue'

export default location



// WEBPACK FOOTER //
// ./src/components/xesMallSearch/components/location/index.js